import { AxiosError } from 'axios';
import { authHeader } from 'services';
import { IManagementCreate, IManagementList } from 'types/Management';

import { Api } from './api/axios.service';

/**
 * Create RH User
 *
 * @param {IManagementCreate} manager
 * @return {*}  {Promise<void>}
 */
const createResponsibleRH = async (
  manager: IManagementCreate
): Promise<void> => {
  try {
    return Api.post('/company/users/create', manager, {
      headers: authHeader(),
    }).then((response) => response.data);
  } catch (error) {
    const { response } = error as AxiosError;
    throw new Error(
      response?.data?.error || 'Não foi possível cadastrar o colaborador'
    );
  }
};

/**
 * List HR Responsible
 *
 * @param {string} id
 * @return {*}  {Promise<IManagementList>}
 */
/** */
const getResponsibleRHList = async (): Promise<IManagementList> => {
  try {
    const { data } = await Api.get<IManagementList>(
      `/company/findAllUsers`,
      {
        headers: authHeader(),
      }
    );
    return data;
  } catch (reason) {
    const { response } = reason as AxiosError<{ error: string }>;

    throw new Error(
      response?.data?.error || 'Não foi possível listar os colaboradores'
    );
  }
};

/**
 * Delete HR Responsible
 *
 * @param {string} companyId
 * @param {string} userId
 * @return {*}  {Promise<any>}
 */
const deleteResponsibleRHById = async (userId: string): Promise<void> => {
  try {
    await Api.delete(`/company/companyUser/${userId}`, {
      headers: authHeader(),
    });
  } catch (reason) {
    const { response } = reason as AxiosError<{ error: string }>;

    throw new Error(
      response?.data?.error || 'Não foi possível deletar o responsável do RH'
    );
  }
};

export const ManagementService = {
  getResponsibleRHList,
  deleteResponsibleRHById,
  createResponsibleRH,
};
